// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__n4thF","error":"Textarea_error__1-9u6","readonly":"Textarea_readonly__1l5rA","disabled":"Textarea_disabled__qRDb6"};